interface IProps {
  message: string
}

function NotFound (props: IProps) {
  return (
    <div className="flex flex-col items-center py-20">
      <img src="/media/socialSearch.svg"/>
      <h4 className="text-xl mt-5 text-[#858C95]">{props.message}</h4>
    </div>
  )
}

export default NotFound